<template>
  <v-container fluid>
    <v-card class="mt-5 mb-10">
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12" sm="3" class="mr-3">
            <v-select
              label="Подразделение"
              item-value="id"
              item-text="fullname"
              v-model="filter.organizationId"
              class="mt-0"
              :loading="false"
              :items="organizationList"
              @change="loadData"
            />
          </v-col>

          <v-col cols="12" sm="3" class="mr-3" align-self="end">
            <DateRangePicker v-model="filter.date" @input="onDateChange" />
          </v-col>

          <v-col cols="12" sm="3" class="mr-3">
            <v-select
              label="Итоговый параметр"
              item-value="id"
              item-text="name"
              v-model="filter.medParam"
              :items="medParamList"
              readonly
              class="mt-0"
              append-icon=""
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-alert v-if="!filter.organizationId" type="warning"><strong>Выберите подразделение</strong></v-alert>

    <v-alert v-if="filter.organizationId && !groupResultItems.length" type="info">
      <strong>Данных за отчетный период не найдено</strong>
    </v-alert>

    <div v-for="(group, gIdx) in groupResultItems" :key="gIdx" class="mb-5">
      <h2>{{ group.name }}</h2>

      <v-simple-table :class="[group.type]">
        <thead>
          <tr>
            <th>ФИО</th>
            <th>Количество выявленных случаев</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in group.items" :key="item.user_id">
            <td>{{ item.fio }}</td>
            <td>{{ item.user_excess }}</td>
          </tr>
        </tbody>
      </v-simple-table>

      <div class="position-relative mt-10">
        <Loader :loading="reportsDataLoading" />

        <v-simple-table v-if="!reportsDataLoading" class="data-per-employee">
          <tbody>
            <tr class="text-center">
              <td colspan="10">
                Отчет за период
                {{ $date(filter.date[0]).format("DD.MM.YYYY") }} - {{ $date(filter.date[1]).format("DD.MM.YYYY") }}
              </td>
            </tr>
            <tr>
              <td colspan="8" style="border-bottom: thin solid rgba(0, 0, 0, 0.12);">Сотрудники</td>
              <td style="border-bottom: thin solid rgba(0, 0, 0, 0.12);">Итоговая оценка за неделю</td>
              <td style="border-bottom: thin solid rgba(0, 0, 0, 0.12);">Итоговая оценка за весь период</td>
            </tr>
          </tbody>

          <template v-for="(report, wIdx) in weekReportsData">
            <tbody :key="`week-${wIdx}`">
              <tr>
                <td colspan="9" class="font-weight-bold">{{ report.fio }}</td>
                <td :rowspan="report.weekCount * 2 + 1" :class="[getPercentColor(report.monthPercent)]"></td>
              </tr>

              <template v-for="(week, index) in report.weeks">
                <tr v-if="week.hasAnyReport" :key="`week-dates-${index}`">
                  <td rowspan="2">Состояние сотрудника на неделе {{ week.range }}</td>
                  <td v-for="(day, indexDay) in week.days" :key="indexDay">
                    {{ day.hasReport ? $date(day.date).format("DD.MM.YYYY") : "" }}
                  </td>
                  <td rowspan="2" :class="[getPercentColor(week.weekPercent)]"></td>
                </tr>
                <tr v-if="week.hasAnyReport" :key="`week-status-${index}`">
                  <td
                    v-for="(day, indexDay) in week.days"
                    :key="indexDay"
                    :class="[getPercentColor(day.day_percent)]"
                    style="border-bottom: thin solid rgba(0, 0, 0, 0.12);"
                  ></td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>

    <div v-if="groupConclusion.length">
      <h2>Заключения за период</h2>

      <v-simple-table>
        <thead>
          <tr>
            <th>Дата</th>
            <th>Доктор</th>
            <th>Подразделение</th>
            <th>
              Заключение за период
              {{ $date(filter.date[0]).format("DD.MM.YYYY") }} - {{ $date(filter.date[1]).format("DD.MM.YYYY") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in groupConclusion" :key="item.id">
            <td>{{ item.created_at }}</td>
            <td>
              <span v-if="item.doctor"
                >{{ item.doctor.user_last_name }} {{ item.doctor.user_first_name }} {{ item.doctor.user_middle_name }}</span
              >
            </td>
            <td>{{ item.org_name }}</td>
            <td>{{ item.recommendation }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
  </v-container>
</template>

<script>
import DateRangePicker from "@/components/forms/DateRangePicker.vue";
import Loader from "@/components/Loader.vue";
import { groupBy } from "lodash";
import dayjs from "dayjs";

export default {
  components: { Loader, DateRangePicker },

  data() {
    return {
      filter: {
        date: [
          this.$date()
            .startOf("month")
            .format("YYYY-MM-DD"),
          this.$date()
            .add(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD"),
        ],
        organizationId: null,
        medParam: 387,
      },
      organizationList: [],
      medParamList: [{ id: 387, name: "Индекс работоспособности" }],
      dataItems: [],
      reportsDataLoading: false,
      weekReportsData: [],
      groupConclusion: [],
    };
  },

  computed: {
    groupResultItems() {
      const result = {
        red: {
          name: "Количество случаев наблюдения критического уровня психофизиологического состояния",
          type: "group-red",
          items: [],
          sort: 1,
        },
        orange: {
          name: "Количество случаев наблюдения оранжевого уровня психофизиологического состояния",
          type: "group-orange",
          items: [],
          sort: 2,
        },
        yellow: {
          name: "Количество случаев наблюдения жёлтого уровня психофизиологического состояния",
          type: "group-yellow",
          items: [],
          sort: 3,
        },
        green: {
          name: "Количество случаев наблюдения зеленого уровня психофизиологического состояния",
          type: "group-green",
          items: [],
          sort: 4,
        },
      };

      this.dataItems.forEach(item => {
        const percent = Number(item.user_percent);

        if (percent >= 40) {
          result.red.items.push(item);
        } else if (percent >= 30) {
          result.orange.items.push(item);
        } else if (percent >= 25) {
          result.yellow.items.push(item);
        } else {
          result.green.items.push(item);
        }
      });

      return Object.values(result)
        .sort((a, b) => a.sort - b.sort)
        .filter(item => item.items.length > 0);
    },
  },

  async created() {
    this.updatePageTitle();

    try {
      const organizationList = await this.$http.get("v1/reports/total-monthly-report/organizations");
      this.organizationList = organizationList?.data?.data || [];
    } catch (e) {
      this.$dialog.notify.error("Ошибка при загрузке данных Организаций");
    }
  },

  methods: {
    updatePageTitle() {
      const start = this.$date(this.filter.date[0]).format("DD.MM.YYYY");
      const end = this.$date(this.filter.date[1]).format("DD.MM.YYYY");
      this.$store.commit("SET_PAGE_TITLE", `Отчет за период ${start} - ${end}`);
    },

    async loadData() {
      try {
        if (!this.filter.organizationId) {
          this.$dialog.message.info("Выберите подразделение");
          return;
        }

        if (!this.filter.date[0] && !this.filter.date[1]) {
          this.$dialog.message.info("Выберите отчетный период");
          return;
        }

        const response = await this.$http.get("v1/reports/total-monthly-report", {
          params: {
            date_start: this.filter.date[0],
            date_end: this.filter.date[1],
            org_structure_id: this.filter.organizationId,
            med_param_id: this.filter.medParam,
          },
        });
        this.dataItems = response?.data?.data || [];
        this.loadReportByCustomers();
        this.loadGroupConclusion();
      } catch (e) {
        this.$dialog.notify.error("Ошибка при загрузке данных");
      }
    },

    onDateChange() {
      this.updatePageTitle();
      this.loadData();
    },

    getPercentColor(percent) {
      if (!percent) {
        return null;
      }

      const numberPercent = parseFloat(percent);

      switch (true) {
        case numberPercent >= 40:
          return "cell-red";
        case numberPercent >= 30:
          return "cell-yellow";
        case numberPercent >= 25:
          return "cell-orange";
        default:
          return "cell-green";
      }
    },

    buildWeekSchema() {
      const weeks = {};

      if (this.filter.date[0] && this.filter.date[1]) {
        const startDate = this.$date(this.filter.date[0]);
        const endDate = startDate.endOf("month");
        const weekCountInPeriod = dayjs.duration(endDate.diff(startDate)).weeks();

        /** @param {import(Dayjs)} date */
        const weekNumberOfYear = date => Number(`${date.format("YYYY")}${date.week()}`);

        /** @param {import(Dayjs)} date */
        const buildWeek = date => {
          const days = {};

          for (let i = 0; i < 7; i++) {
            const day = date
              .startOf("week")
              .add(i, "day")
              .format("YYYY-MM-DD");

            days[day] = {
              isCurrentMonth: date.isSame(day, "month"),
              hasReport: false,
            };
          }

          const endWeek = date.endOf("week").isAfter(date.endOf("month")) ? date.endOf("month") : date.endOf("week");

          return {
            weekNumber: weekNumberOfYear(date),
            range: `${date.format("DD.MM.YYYY")} - ${endWeek.format("DD.MM.YYYY")}`,
            hasAnyReport: false,
            days,
          };
        };

        // Добавляем первую неделю
        weeks[weekNumberOfYear(startDate)] = buildWeek(startDate);

        // Добавляем остальные недели перебором
        for (let i = 1; i <= weekCountInPeriod; i++) {
          const week = startDate.add(i, "week").startOf("week");
          weeks[weekNumberOfYear(week)] = buildWeek(week);
        }
      }

      return weeks;
    },

    async loadReportByCustomers() {
      const requests = [];

      this.dataItems.forEach(item => {
        const promise = new Promise(resolve => {
          this.$http
            .get("v1/reports/total-monthly-user-report", {
              params: {
                user_id: item.user_id,
                med_param_id: this.filter.medParam,
                date_start: this.filter.date[0],
                date_end: this.filter.date[1],
              },
            })
            .then(res => {
              resolve({
                fio: item.fio,
                items: res.data.data,
              });
            });
        });

        requests.push(promise);
      });

      try {
        this.reportsDataLoading = true;
        const response = await Promise.all(requests);

        response.forEach(report => {
          this.weekReportsData = [];
          const weeksSchema = this.buildWeekSchema();
          const weeks = groupBy(report.items, "week");

          let weekCount = 0;
          let monthPercent = null;
          Object.keys(weeksSchema).forEach(weekNumber => {
            if (weeks[weekNumber]) {
              weekCount++;
              weeks[weekNumber].forEach(day => {
                weeksSchema[weekNumber].hasAnyReport = true;
                weeksSchema[weekNumber].days[day.date] = { ...weeksSchema[weekNumber].days[day.date], ...day, hasReport: true };

                if (day.week_percent) {
                  weeksSchema[weekNumber].weekPercent = day.week_percent;
                }

                if (day.month_percent) {
                  monthPercent = day.month_percent;
                }
              });
            } else {
              delete weeksSchema[weekNumber];
            }
          });

          this.weekReportsData.push({
            fio: report.fio,
            weekCount,
            monthPercent,
            weeks: weeksSchema,
          });
        });
      } catch (e) {
        console.log(e);
        this.$dialog.notify.error("Ошибка при загрузке данных по пользователям");
      } finally {
        this.reportsDataLoading = false;
      }
    },

    async loadGroupConclusion() {
      const result = await this.$http.get("v1/group-conclusion", {
        params: {
          organization_id: this.filter.organizationId,
          date: this.filter.date,
        },
      });

      this.groupConclusion = (result.data.data || []).map(item => {
        let created_at = new Date(Date.parse(item.created_at));

        return { ...item, created_at: created_at.toLocaleString() };
      });
    },
  },
};
</script>

<style scoped lang="scss">
.v-data-table {
  &.group-red {
    border: 1px solid red;
  }

  &.group-orange {
    border: 1px solid orange;
  }

  &.group-yellow {
    border: 1px solid yellow;
  }

  &.group-green {
    border: 1px solid green;
  }
}

.total-excess {
  &.group-red {
    background-color: red;
    color: #fff;
  }

  &.group-orange {
    background-color: orange;
  }

  &.group-yellow {
    background-color: yellow;
  }

  .total-excess.group-green {
    background-color: green;
    color: #fff;
  }
}

.cell-gray {
  background-color: gray;
}

.cell-red {
  background-color: red;
}

.cell-orange {
  background-color: orange;
}

.cell-yellow {
  background-color: yellow;
}

.cell-green {
  background-color: green;
}

.data-per-employee {
  td {
    border-right: thin solid rgba(0, 0, 0, 0.12) !important;
  }
}
</style>
}
